/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabAssistant from './diaglab-assistant';
import DiaglabAssistantDetail from './diaglab-assistant-detail';
import DiaglabAssistantUpdate from './diaglab-assistant-update';
import DiaglabAssistantDeleteDialog from './diaglab-assistant-delete-dialog';

const DiaglabAssistantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabAssistant />} />
    <Route path="new" element={<DiaglabAssistantUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabAssistantDetail />} />
      <Route path="edit" element={<DiaglabAssistantUpdate />} />
      <Route path="delete" element={<DiaglabAssistantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabAssistantRoutes;
